import { bridge } from '../../../bridge';

/**
 * - 찜 서랍 페이지로 이동
 */
export const moveToLikeFolders = ({ folderSno }: { folderSno: number }) => {
  bridge.openDeeplink(`ably://like/folders/${folderSno}`);
};
